<span>{{ username | translate }}</span>
<span *ngIf="isDisabled">
	<sdp-icon [icon]="disabledIcon"></sdp-icon>
</span>